var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00913 16.1358L4.1421 4.00014H3C2.44772 4.00014 2 3.55242 2 3.00014C2 2.44785 2.44772 2.00014 3 2.00014H4.9847C5.0806 1.99855 5.17434 2.0108 5.26367 2.03526C5.40561 2.07396 5.53497 2.14314 5.64429 2.23533C5.76213 2.33451 5.85751 2.46104 5.91981 2.60712C5.95413 2.68733 5.97826 2.77295 5.99058 2.86233L6.31948 5.00014H14V7.00014H6.62717L7.85794 15.0001H17.256L18.756 10.0001H20.844L18.9578 16.2875C18.8309 16.7105 18.4416 17.0001 18 17.0001H7.01578C6.92133 17.0017 6.82899 16.9899 6.74088 16.9662C6.59074 16.9261 6.45453 16.8518 6.34104 16.7523C6.2371 16.6614 6.15157 16.5487 6.0921 16.4199C6.05113 16.3314 6.02271 16.236 6.00913 16.1358Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0001C10 21.1047 9.10457 22.0001 8 22.0001C6.89543 22.0001 6 21.1047 6 20.0001C6 18.8956 6.89543 18.0001 8 18.0001C9.10457 18.0001 10 18.8956 10 20.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.0001C19 21.1047 18.1046 22.0001 17 22.0001C15.8954 22.0001 15 21.1047 15 20.0001C15 18.8956 15.8954 18.0001 17 18.0001C18.1046 18.0001 19 18.8956 19 20.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.00014C19.5523 2.00014 20 2.44785 20 3.00014V4.00014H21C21.5523 4.00014 22 4.44785 22 5.00014C22 5.55242 21.5523 6.00014 21 6.00014H20V7.00014C20 7.55242 19.5523 8.00014 19 8.00014C18.4477 8.00014 18 7.55242 18 7.00014V6.00014H17C16.4477 6.00014 16 5.55242 16 5.00014C16 4.44785 16.4477 4.00014 17 4.00014H18V3.00014C18 2.44785 18.4477 2.00014 19 2.00014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartAdd);
export default __webpack_public_path__ + "static/media/shopping-cart-add.8444ff6a45b31e139e1a50a13d96394e.svg";
export { ForwardRef as ReactComponent };